<staff-login>
  <form onsubmit="{ onFormSubmit }" class="login-form">
    <input type="password" name="dummypass" autocomplete="current-password"
      style="top: -2000px; left: -2000px; position: fixed;">
    <div class="form-group">
      <label class="form-label" for="staffId">スタッフ</label>
      <select name="staffId" class="form-control form-control-just">
        <option each="{ (staff,i) in props.staffs }" key="{ i }" value="{ staff.id }"
          selected="{ state.staffId == staff.id }">
          { staff.name }
        </option>
      </select>
    </div>

    <div class="form-group">
      <label class="form-label" for="password">パスワード</label>
      <input class="form-control" type="password" name="password" id="password" autocomplete="current-password"
        value="{ state.password }" required oninput="{ onPasswordChange }">
    </div>

    <div class="form-group">
      <label for="showPasswordCheck" class="tooltip">
        <input type="checkbox" name="showPasswordCheck" id="showPasswordCheck" onchange="{ togglePassword }"
          disabled="{ !state.canShowPassword }" checked="{ state.showingPassword }">
        <small>パスワードを表示する</small>
        <span class="tooltip-box" if="{ !state.canShowPassword }">パスワードを表示したい場合は
          一度削除してください。
        </span>
      </label>
    </div>

    <div class="form-group">
      <label for="saveInputCheck">
        <input type="checkbox" name="saveInputCheck" id="saveInputCheck" checked="{ state.saveInputCheck }">
        <small>入力内容を保存する</small>
      </label>
    </div>
    <button class="btn btn-green login-btn">ログイン</a></button>
  </form>
  <script>
    import storage from '@/common/storage';
    import { serializeForm } from '@/common/utils/dom';
    import tabChannel from '@/worker/tab-channel/top';
    import checkUA from '../check-ua';
    export default {
      state: {
        staffId: '',
        password: '',
        canShowPassword: false,
        showingPassword: false,
        saveInputCheck: true,
      },

      onBeforeMount() {
        const keyStaffId = `${this.props.officeId}_staffId`;
        const keyStaffPass = `${this.props.officeId}_staffPass`;
        this.state.staffId = storage.getItem(keyStaffId);
        this.state.password = storage.getItem(keyStaffPass);
        this.state.canShowPassword = !this.state.password;
        this.state.showingPassword = false;
        this.state.saveInputCheck = storage.getItem('staff_saveInputCheck') != '0';
      },

      onPasswordChange(e) {
        if (!this.state.showingPassword) {
          this.state.canShowPassword = !e.target.value;
          this.update();
        }
      },

      async onMounted() {
        window.addEventListener('popstate', this.popState);
        if (storage.getMode() != null) {
          tabChannel.init();
        }
        await this.props.init();
        const keyStaffId = `${this.props.officeId}_staffId`;
        const keyStaffPass = `${this.props.officeId}_staffPass`;
        const staffId = storage.getItem(keyStaffId);
        const password = storage.getItem(keyStaffPass);
        const staffName = storage.getVpSetting().vbLoginAuto;
        const staff = this.props.staffs.find(staff => staff.name == staffName);
        const hasAuth = staffId && password;
        const isMain = this.props.startMain && storage.getHwKey() != null;
        const isSub = this.props.startSub;
        const isVpStarted = isMain || isSub;
        const vpType = storage.getVpType();
        if (vpType == 'vpm' || isVpStarted) {
          history.pushState(null, null, null);
        }
        if (isVpStarted && hasAuth && staffId == staff?.id) {
          return this.props.login({
            staffId,
            password,
            saveInputCheck: true
          });
        }
        const offSet = new Date().getTimezoneOffset();
        if (offSet != -540) {
          this.props.openInfoDialog('ご利用端末のタイムゾーン設定を日本に変更してください。');
        }
        if (checkUA()) {
          this.props.openInfoDialog('ブラウザのバージョンが古いため、正常に動作しない可能性があります。');
        }
      },

      onUnmounted() {
        window.removeEventListener('popstate', this.popState);
      },

      popState() {
        const isMain = this.props.startMain && storage.getHwKey() != null;
        const isSub = this.props.startSub;
        const isVpStarted = isMain || isSub;
        const vpType = storage.getVpType();
        if (vpType == 'vpm' || isVpStarted) {
          history.pushState(null, null, null);
          return;
        }
      },

      togglePassword() {
        this.state.showingPassword = !this.state.showingPassword;
        const passwordElement = this.$('#password');
        const type = passwordElement.getAttribute('type');
        this.$('#password').setAttribute('type', type == 'password' ? 'text' : 'password');
      },

      onFormSubmit(e) {
        e.preventDefault();
        const data = serializeForm(e.target);
        this.props.login(data);
      }
    };
  </script>
  <style>
    .login-btn {
      margin-top: 16px;
      width: 100%;
    }

    .tooltip-box {
      display: none;
      position: absolute;
      font-weight: normal;
      font-size: 12px;
      padding: 6px;
      margin-left: 4px;
      background-color: rgb(255, 255, 255);
      box-shadow: 0 1px 3px 2px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      border-radius: 3px;
      white-space: pre-line;
      z-index: 1;
    }

    .tooltip:hover .tooltip-box {
      display: inline;
    }
  </style>
</staff-login>